export enum PropertyImageSizes {
  xsm = 24,
  sm = 40,
  m = 48,
  l = 64,
  xl = 120,
  xxl = 170,
}
